import produce from 'immer';
import { TitleTestEnum } from 'src/utils/enum';
import { TITLE_CREATE_TEST_NEW, TITLE_CREATE_TEST_EDIT } from './constants';
import {
  TitleTestNew,
  TitleTestEdit,
  TitleCreateTestType,
  TitleCreateTestActionTypes,
} from './types';

const initialState: TitleCreateTestType = {
  id: TitleTestEnum.Edit,
  name: 'Редактирование опроса',
};

export default produce(
  (
    draft = initialState,
    action: TitleCreateTestActionTypes,
  ): TitleCreateTestType => {
    switch (action.type) {
      case TITLE_CREATE_TEST_NEW: {
        draft = (action as TitleTestNew).payload;
        return draft;
      }
      case TITLE_CREATE_TEST_EDIT: {
        draft = (action as TitleTestEdit).payload;
        return draft;
      }

      default:
        return draft;
    }
  },
);
